import { Routes } from '@angular/router';
import { OrderShipmentsComponent } from './modules/order-shipments/components/order-shipments/order-shipments.component';
import { DriveDeliveryStatusComponent } from './modules/drive-delivery-status/components/drive-delivery-status/drive-delivery-status.component';
import { OperationalDashboardComponent } from './modules/operational-dashboard/components/operational-dashboard/operational-dashboard.component';
import { UpcomingOrdersComponent } from './modules/operational-dashboard/components/upcoming-orders/upcoming-orders.component';
import { ErrorsByShipDateComponent } from './modules/operational-dashboard/components/errors-by-ship-date/errors-by-ship-date.component';
import { ErrorsByComponentComponent } from './modules/operational-dashboard/components/errors-by-component/errors-by-component.component';
import { ComponentStatusComponent } from './modules/operational-dashboard/components/component-status/component-status.component';
import { UpcomingOrdersWithMissingContentComponent } from './modules/operational-dashboard/components/upcoming-orders-with-missing-content/upcoming-orders-with-missing-content.component';
import { OrdersByStatusComponent } from './modules/operational-dashboard/components/orders-by-status/orders-by-status.component';
import { CvdDongleInfoComponent } from './modules/operational-dashboard/components/cvd-dongle-info/cvd-dongle-info.component';
import { TrendingTitlesComponent } from './modules/operational-dashboard/components/trending-titles/trending-titles.component';

export const insightRoutes: Routes = [
  {
    path: 'order-shipment',
    component: OrderShipmentsComponent
  },
  {
    path: 'operational-dashboard',
    children: [
      {
        path: '',
        component: OperationalDashboardComponent,
      },
      {
        path: 'upcoming-orders',
        component: UpcomingOrdersComponent
      },
      {
        path: 'errors-by-ship-date',
        component: ErrorsByShipDateComponent
      },
      {
        path: 'errors-by-component',
        component: ErrorsByComponentComponent
      },
      {
        path: 'component-status',
        component: ComponentStatusComponent
      },
      {
        path: 'upcoming-orders-with-missing-content',
        component: UpcomingOrdersWithMissingContentComponent
      },
      {
        path: 'orders-by-status',
        component: OrdersByStatusComponent
      },
      {
        path: 'cvd-dongle-info',
        component: CvdDongleInfoComponent
      },
      {
        path: 'trending-titles',
        component: TrendingTitlesComponent
      }
    ]
  },
  {
    path: 'drive-delivery-status',
    component: DriveDeliveryStatusComponent
  },
  {
    path: '',
    redirectTo: 'order-shipment',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'order-shipment'
  }
];
